import axios from "./AxiosInstance"
const getAll = (userId) => {
    let url = `api/reports`
    if (userId) {
        url += `?patientId=${userId}`
    }

    return axios.get(url)
}

export const ReportService = {
    getAll
}
